import i18n from '@dms/i18n';

import {Field} from './primitives/Field';

export function IsAcceptableForTechnicalInspectionCheckbox() {
  return (
    <Field
      type="checkbox"
      name="isAcceptableForTechnicalInspection"
      label={i18n.t('entity.vehicle.labels.acceptableTechnicalCondition')}
    />
  );
}
